import { createContext } from 'react';
import { MessageParking, MessageTicket, RecommendableBundle } from '../../domain/bundles/recommendable-bundle';
import { ApplicableBundle } from '../../domain/bundles';
import { BundleDisclaimerResponse } from '../../domain/bundles/disclaimer-bundle';

// ********************************************************************************
export interface BundleRecommendationContextState {
  recommendation: RecommendableBundle | null;
  disclaimer: BundleDisclaimerResponse | null;
  ticketMessages: MessageTicket | null;
  parkingMessages: MessageParking | null;
  totalDiscount: number;
  totalOriginal: number;
}

export const initialBundleRecommendationContext: BundleRecommendationContextState = {
  recommendation: null,
  disclaimer: null,
  ticketMessages: null,
  parkingMessages: null,
  totalDiscount: 0,
  totalOriginal: 0,
}

export const BundleRecommendationContext = createContext<BundleRecommendationContextState>(initialBundleRecommendationContext);